import axios from 'axios'
var config = require('../config.js')
var utils = require('../utility/utility.js')
var commonAddress = config.commonAddress4S + '/service/intserv/'
var commomHeaders = {
	'Content-Type': 'application/json'
}

var post = function (url, data) {
	data = data || {}
	// 判断本地存储token是否存在
	let localUserInfo = utils.localUserInfo
	if (localUserInfo.getItem()) {
		data.companyId = localUserInfo.getItem().company_id
	} else {
		utils.showToast('登录已过期！请重新登录')
		// 登录过期，清空缓存数据
		localStorage.clear()
		sessionStorage.clear()
		window.location.href = '/'
		return false
	}
	// console.log('data', data)

	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: commonAddress + url + '.json',
			headers: commomHeaders,
			data: data
		})
			.then(function (res) {
				// console.log('res.data', res.data)
				// 用户token过期，提示用户重新登录
				if (res.data.ErrCode === 1001) {
					utils.showToast('登录已过期！请重新登录')
					// 登录过期，清空缓存数据
					localStorage.clear()
					sessionStorage.clear()
					window.location.href = '/'
					return false
				}
				resolve(res.data)
			})
			.catch(function (error) {
				utils.hideLoading()
				utils.showToast('连接服务器失败，取消操作请重试！')
				// console.log('error', error)
				reject(error)
			})
	})
}


let dkbApi = {
	// 获取固定（通用）版块的信息
	getGMInfo() {
		return post('GetGMInfo')
	},
	// 获取固定（通用）版块的设备信息
	getGMDeviceInfo() {
		return post('GetGMDeviceInfo')
	},
	// 获取固定（通用）版块的实时操作记录
	getGMRealOperateInfo() {
		return post('GetGMRealOperateInfo')
	},
	// 获取固定（通用）版块的库存记录
	getGMKCSLInfo() {
		return post('GetGMKCSLInfo')
	},
	// 获取固定（通用）版块的预警信息
	getGMWarningInfo() {
		return post('GetGMWarningInfo')
	},
	// 获取固定（通用）版块的信息
	GetAllAuthorityList(data) {
		return post('GetAllAuthorityList', data)
	},
	// 获取全屏档案馆的信息
	getFSNARAInfo(data) {
		return post('GetFSNARAInfo', data)
	},
	// 获取全屏档案馆的库存信息
	getFSNARAStockInfo(data) {
		return post('GetStockInfo', data)
	},
	// 获取全屏档案馆的借还记录
	getFSNARARecordList(data) {
		return post('GetFSNARARecordList', data)
	},
	// 获取全屏档案馆温湿度信息
	getNARATHInfo(data) {
		return post('GetNARATHInfo', data)
	},
	// 获取档案馆信息-库存数量、借还记录（小屏）
	getNARAInfo() {
		return post('GetNARAInfo')
	},
	// 获取档案室水电表信息(全屏)
	GetFSNARAWEInfo(data) {
		return post('GetFSNARAWEInfo', data)
	},
	// 获取档案室消毒机操作记录(全屏)
	GetFSNARASterilizerRecordList(data) {
		return post('GetFSNARASterilizerRecordList', data)
	},
	// 获取档案室设备温湿度(全屏)
	GetDeviceTHInfo(data) {
		return post('GetDeviceTHInfo', data)
	},
	// 获取温湿度设备信息(小屏)
	GetHumitureInfo(data) {
		return post('GetHumitureInfo', data)
	},
	// 获取会议室信息（小屏）
	GetMRInfo(data) {
		return post('GetMRInfo', data)
	},
	// 获取柜体总体数据信息
	GetCabinetInfo(data) {
		return post('GetCabinetInfo', data)
	},
	// 获取人脸门禁识别记录（小屏）
	GetAccessRecord(data) {
		return post('GetAccessRecord', data)
	},
	// 获取门禁访客预约情况（小屏）
	GetAccessCase(data) {
		return post('GetAccessCase', data)
	},
	// 获取能耗水电表信息(小屏)
	GetTCEInfo(data) {
		return post('GetTCEInfo', data)
	},
}


export {
	dkbApi
}


//////////////////
// WEBPACK FOOTER
// ./static/js/dkb/dkb.js
// module id = null
// module chunks = 